module.exports = __webpack_public_path__ + "img/favicon.6af1faa5.svg";